import React, { useState, useEffect, useContext } from 'react';
import AudioContext from './components/AudioContext';
import './App.css';
import './responsive.css';
import Dashboard from './components/dashboard';
import Shop from './components/shop';
import Inventory from './components/Inventory'
import Treasury from './components/Treasury';
import Settings from './components/Settings'
import Workforce from './components/workforce';
import Lottery from './components/lottery';
import Nestwars from './components/nestwars.js';
import Leveling from './components/leveling';
import LevelingUnAssign from './components/levelingUnassign';
import TasksUnAssign from './components/tasksUnassign';
import Tasks from './components/tasks';
import Gathering from './components/gathering';
import News from './components/News.js';
import Bosses from './components/bossfights';
import Incubating from './components/incubating';
import Referral from './components/referral';
import WorkforceAssign from './components/workforceAssign';
import LevelingAssign from './components/levelingAssign';
import TasksAssign from './components/tasksAssign';
import WorkforceUnAssign from './components/workforceUnassign';
import BossesAssign from './components/bossesAssign';
import BossesUnAssign from './components/bossesUnassign';
import LoginPopup from './components/LoginPopup';
import ButtonBack from './components/images/Icon_Close.png';
import MenuTop from './components/MenuTop';
import MenuBottom from './components/MenuBottom';
import MenuRight from './components/MenuRight';
import useSolanaWeb3 from './hooks/useSolanaWeb3'; // Updated for Solana
import { Toaster } from 'react-hot-toast';
import PastLottery from './components/Pastlottery';
import UseLevelingPotion from './components/UseLevelingPotion';
import PurseOpenPopup from './components/PurseOpenPopup';
import Audio from './audio/background.mp3';
import ClickSound from './audio/Click.mp3';
import '@solana/wallet-adapter-react-ui/styles.css';
import ItemsReceived from './components/ItemsReceived';
// import { NftProvider } from './contexts/NftContext';
import { NftProvider } from './contexts/NftContext.js';
import { doc, setDoc, arrayUnion, getDoc, updateDoc, runTransaction } from 'firebase/firestore';
import { db } from './components/firebaseConfig';
import { useDispatch, useSelector } from 'react-redux';
import { increment } from './store/appSlice.js';
import { selectAppStore } from './store/appSlice.js';
import useFetchNfts from './hooks/useFetchNfts.js';
import apiFetchNfts from './apis'
const SettingsContext = React.createContext();

function App() {
  const [volume, setVolume] = useState(1);
  const [volumefx, setVolumefx] = useState(1);
  const [activeComponent, setActiveComponent] = useState('dashboard');
  const [componentHistory, setComponentHistory] = useState([]);
  const [notification, setNotification] = useState('');
  const [showSettings, setShowSettings] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(true);
  const { wallet, connected, fetchAssignedNfts,fetchBossedNfts, fetchTaskedNfts } = useSolanaWeb3(); // Updated for Solana
  const [walletAddress, setWalletAddress] = useState('');
  const [isPortrait, setIsPortrait] = useState(window.innerWidth < window.innerHeight);
  const { fetchNfts } = useFetchNfts()
  const [showNews, setShowNews] = useState(true);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);

    // Initial check
    handleOrientationChange();

    // Cleanup function
    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  const orientationOverlay = (
    <div style={{
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'black',
      color: 'white',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '24px',
      zIndex: 10000, // Ensure it covers your app content
    }}>
      Please rotate your device to landscape mode.
    </div>
  );

   const isMobileDevice = () => {
    return ('ontouchstart' in window || navigator.maxTouchPoints) && window.innerWidth <= 800;
  };

  const enterFullScreen = () => {
    if (!document.fullscreenElement && isMobileDevice()) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      // If the document is no longer in fullscreen, re-attach the event listener
      if (!document.fullscreenElement) {
        document.addEventListener('click', enterFullScreen);
      }
    };

    // Only attach the event listener for mobile devices
    if (isMobileDevice()) {
      document.addEventListener('click', enterFullScreen);
      document.addEventListener('fullscreenchange', handleFullScreenChange);
      document.addEventListener('webkitfullscreenchange', handleFullScreenChange); // For Safari
      document.addEventListener('mozfullscreenchange', handleFullScreenChange); // For Firefox
      document.addEventListener('MSFullscreenChange', handleFullScreenChange); // For IE
    }

    // Cleanup function to remove the event listeners
    return () => {
      document.removeEventListener('click', enterFullScreen);
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange); // For Safari
      document.removeEventListener('mozfullscreenchange', handleFullScreenChange); // For Firefox
      document.removeEventListener('MSFullscreenChange', handleFullScreenChange); // For IE
    };
  }, []);

  useEffect(() => {
    if (connected) {
      console.log('fetchNfts in App')
      fetchNfts()
      fetchAssignedNfts()
      fetchBossedNfts()
      fetchTaskedNfts()
      setShowLoginPopup(false);
      const walletAddress = wallet.publicKey.toString();
  
      const processReferral = async () => {
        const referrerId = sessionStorage.getItem('referrerId');
  
        // Skip the referral process if the user's wallet address is the same as the referrer's ID
        if (referrerId && walletAddress === referrerId) {
          console.log('Cannot refer yourself.');
          sessionStorage.removeItem('referrerId'); // Consider removing this as per your logic needs
          return;
        }
  
        try {
          // Ensure the current user is added or updated in the "users" collection
          const userData = { walletAddress, ...(referrerId && { referredBy: referrerId }) };
          await setDoc(doc(db, "users", walletAddress), userData, { merge: true });
          
          if (referrerId) {
            // Use a transaction for consistent read-write operations
            await runTransaction(db, async (transaction) => {
              const referrerDocRef = doc(db, "referrals", referrerId);
              const referrerDoc = await transaction.get(referrerDocRef);
  
              if (!referrerDoc.exists()) {
                transaction.set(referrerDocRef, { referrals: [walletAddress] });
              } else {
                transaction.update(referrerDocRef, { referrals: arrayUnion(walletAddress) });
              }
            });
            console.log("Referral info updated in Firestore for referrer:", referrerId);
          }
        } catch (error) {
          console.error("Error processing referral:", error);
        } finally {
          sessionStorage.removeItem('referrerId');
        }
      };
  
      processReferral();
    }
  }, [connected, wallet]);

  useEffect(() => {
    const music = document.getElementById("background-music");
    if (music) music.volume = volume;
  }, [volume]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const referrerId = queryParams.get('ref');
    if (referrerId) {
      sessionStorage.setItem('referrerId', referrerId);
    }
  }, []);

  useEffect(() => {
    if (connected) {
      console.log("Wallet connected status:", connected);
      setShowLoginPopup(false)
    }
    else {
      setShowLoginPopup(true)
    }
  }, [connected]);

  // Refresh the current web page on switching the current wallet account
  // useEffect(()=>{
  //   let interval;
  //   if(wallet.publicKey){
  //     interval = setInterval(()=>{
  //       if(wallet.publicKey?.toBase58() !== window.solana?.publicKey?.toBase58()) {
  //         window.location.reload()
  //       }
  //     },1000)
  //   }
  //   return (
  //     ()=>{
  //       if(interval) clearInterval(interval)
  //     }
  //   )
  // },[wallet])


  const changeActiveComponent = (newComponent) => {
    setComponentHistory([...componentHistory, activeComponent]);
    setActiveComponent(newComponent);
  };

  const goBack = () => {
    if (componentHistory.length > 0) {
      const lastComponent = componentHistory[componentHistory.length - 1];
      setComponentHistory(componentHistory.slice(0, -1));
      setActiveComponent(lastComponent);
    }
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => {
      setNotification('');
    }, 5000);
  };

  const hideNotification = () => {
    setNotification('');
  };

  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };

  const handleCloseNews = () => {
    setShowNews(false); // Step 3: Set showNews to false
  };

  const toggleNews = () => {
    setShowNews(prevShowNews => !prevShowNews);
  };

  return (
    <NftProvider>
    <div className="App">
      {isPortrait && orientationOverlay}
      <div className="app-content">
      <AudioContext.Provider value={{ volume, setVolume, volumefx, setVolumefx }}>
          <SettingsContext.Provider value={{ showSettings, toggleSettings }}>
          {showLoginPopup && !connected && <LoginPopup onClose={() => setShowLoginPopup(false)} connected={connected} />}
            {showSettings && (
              <Settings changeActiveComponent={changeActiveComponent} onClose={toggleSettings} isConnected={connected} />
            )}
            {activeComponent === 'dashboard' && <Dashboard changeActiveComponent={changeActiveComponent} />}
            {activeComponent === 'workforce' && <Workforce changeActiveComponent={changeActiveComponent} />}
            {activeComponent === 'leveling' && <Leveling changeActiveComponent={changeActiveComponent} />}
            {activeComponent === 'tasks' && <Tasks changeActiveComponent={changeActiveComponent} />}
            {activeComponent === 'bosses' && <Bosses changeActiveComponent={changeActiveComponent} />}
            {showNews && <News onClose={handleCloseNews} />}
            <MenuRight changeActiveComponent={changeActiveComponent} activeComponent={activeComponent} toggleNews={toggleNews} />
            <MenuBottom changeActiveComponent={changeActiveComponent} activeComponent={activeComponent} />
            {activeComponent === 'incubating' && <Incubating changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'referral' && <Referral goBack={goBack} walletAddress={walletAddress} />}
            {activeComponent === 'tasksassign' && <TasksAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'bossesassign' && <BossesAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'bossesunassign' && <BossesUnAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'tasksunassign' && <TasksUnAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'levelingassign' && <LevelingAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'levelingunassign' && <LevelingUnAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'workforceassign' && <WorkforceAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'workforceunassign' && <WorkforceUnAssign changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'shop' && <Shop changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'lottery' && <Lottery changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'nestwars' && <Nestwars changeActiveComponent={changeActiveComponent} goBack={goBack} />}  
            {activeComponent === 'gathering' && <Gathering changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'pastlottery' && <PastLottery changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'inventory' && <Inventory changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'treasury' && <Treasury changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            {activeComponent === 'uselevelingpotion' && <UseLevelingPotion changeActiveComponent={changeActiveComponent} goBack={goBack} />}
            <MenuTop changeActiveComponent={changeActiveComponent} setWalletAddress={setWalletAddress} />
            {notification && (
              <div className="notification">
                <h1>NOTIFICATION</h1>
                <p>{notification}</p>
                <button className="button-close" id="notification-close" onClick={hideNotification}><img src={ButtonBack} alt="Close button" /></button>
              </div>
            )}
          </SettingsContext.Provider>
          </AudioContext.Provider>
      </div>
      <Toaster />
    </div>
    </NftProvider>
  );
}

export default App;
export { SettingsContext };